module.exports = __webpack_public_path__ + "static/media/podcast.024b04d7.jpg";